<template lang="html">
    <div class="view-login">
        <div class="form-login">

            <h1>Connexion</h1>

            <el-form
                ref="formLogin"
                :model="form"
                :rules="rules">

                <el-form-item
                    label="Email"
                    prop="email">
                    <el-input
                        v-model="form.email"
                        @keyup.enter.native="login">
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-if="showPassword"
                    label="Mot de passe"
                    prop="password">
                    <el-input
                        v-model="form.password"
                        type="text"
                        @keyup.enter.native="login">
                        <el-button
                            slot="append"
                            @click="showPassword = false">
                            <v-icon name="eye-slash"></v-icon>
                            &nbsp;
                        </el-button>
                    </el-input>
                </el-form-item>

                <el-form-item
                    v-else
                    label="Mot de passe"
                    prop="password">
                    <el-input
                        v-model="form.password"
                        type="password"
                        @keyup.enter.native="login">
                        <el-button
                            slot="append"
                            @click="showPassword = true">
                            <v-icon name="eye"></v-icon>
                            &nbsp;
                        </el-button>
                    </el-input>
                </el-form-item>
            </el-form>

            <el-button
                :loading="loading"
                type="primary"
                style="width:100%"
                @click="login">
                Se connecter
            </el-button>

        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data () {
        return {
            loading: false,
            showPassword: false,
            form: {
                email: '',
                password: ''
            },
            rules: {
                email: [
                    { required: true, message: 'L\'email est obligatoire', trigger: 'blur' },
                    { type: 'email', message: 'L\'email doit être une adresse valide', trigger: ['blur', 'change'] }
                ],
                password: [
                    { required: true, message: 'Le mot de passe est  obligatoire', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        login () {
            this.$refs.formLogin.validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.$store.dispatch('loginUser', this.form)
                        .then(() => {
                            this.loading = false;
                        }).catch(() => {
                            this.loading = false;
                            this.$notify({
                                title: 'Erreur',
                                message: 'Vos identifiants sont incorrectes. Veuillez réessayer',
                                type: 'error'
                            });
                        });
                } else {
                    this.$notify({
                        title: 'Erreur',
                        message: 'Le formulaire n\'a pas été envoyé car il contient des champs erronés.',
                        type: 'error'
                    });
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss">
.view-login {
    position: relative;
    min-height: 100vh;
    height: 100%;
    background: url('../../../../static/images/motor-view-large-background.jpg') no-repeat center center;
    background-size: cover;
    .form-login {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 280px;
        padding: 20px;
        background: white;
        box-shadow: 0px 3px 20px 0px rgba(0,0,0,0.75);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Login/index.vue